import { Directive, ElementRef, HostListener, Input, OnInit, Optional, Renderer2 } from '@angular/core';
import { CxModalInstance } from './cx-modal-instance.service';

@Directive({
  /* tslint:disable */
  // DCM001CMG01-13553
  // :not([open]] will make cxmodalcomponent more isolated from old modals as it doesn't require open property
  selector: 'cwc-modal:not([open])',
  exportAs: 'cxModal',
})
export class CxModalComponent implements OnInit {
  constructor(
    private rdr2: Renderer2,
    private host: ElementRef,
    @Optional() private cxModalInstance?: CxModalInstance,
  ) {
    if (!cxModalInstance) {
      console.warn('☸ CxModalInstance was not provided for Modal component. Please check Component providers.');
    }
  }

  @Input()
  public id!: string;

  @Input()
  public open = true;

  public ngOnInit() {
    if (this.open) {
      this.rdr2.setProperty(this.host.nativeElement, 'open', this.open);
    }
  }

  @HostListener('cwcClose')
  public onClose() {
    if (this.cxModalInstance) {
      this.rdr2.setProperty(this.host.nativeElement, 'open', false);

      // Animation delay
      setTimeout(() => {
        this.cxModalInstance.cxRemoveInstance();
      }, 500);
    }
  }
}
